import {
  SELECT_INCIDENT_STATUS_FILTER,
  CLEAR_INCIDENT_STATUS_FILTER,
} from "./incidentActionTypes";
import { LOAD_OPEN_INCIDENT_SUCCESS, LOAD_CLOSE_INCIDENT_SUCCESS } from "./incidentActionTypes";

const INITIAL_STATE = [];
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_INCIDENT_STATUS_FILTER: {
      const exists = state.filter((f) => f === action.value).length > 0;
      if (exists) {
        return state.filter((f) => f !== action.value);
      }
      return [...state, action.value];
    }
    case CLEAR_INCIDENT_STATUS_FILTER: {
      return INITIAL_STATE;
    }

    case LOAD_OPEN_INCIDENT_SUCCESS:
    case LOAD_CLOSE_INCIDENT_SUCCESS: {
      if (state.length > 0) {
        if (action.logIncident.incidents.some((e) => e.Status === "New")) {
          return [...state, "New"].filter((e, i, a) => a.indexOf(e) == i);
        }
        if (action.logIncident.incidents.some((e) => e.Status === "Open")) {
          return [...state, "Open"].filter((e, i, a) => a.indexOf(e) == i);
        } else {
          if (action.logIncident.incidents !== undefined && action.logIncident.incidents.length > 0) {
            return [...state, action.logIncident.incidents[0].Status].filter((e, i, a) => a.indexOf(e) == i);
          } else {
            return state;
          }
        }
      } else {
        return state;
      }
    }


    case "@@router/LOCATION_CHANGE": {
      return ["New"];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/incidents/incidentsStatusFilterReducer.js